import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./EditChatName.css";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { updateNewChat } from "../../redux/chatData";
import { useDispatch } from "react-redux";
import Spinner from "../Spinner/Spinner";

const EditChatNameModal = ({ isOpen, onClose, chat }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setName(chat?.name);
  }, [isOpen]);

  const editChatName = async () => {
    const payload = {
      id: chat?._id,
      name: name,
    };

    try {
      setLoading(true);
      const response = await apiServiceHandler(
        "POST",
        "api/chat/update",
        payload
      );
      if (response.status) {
        toastr.success(response.message);
        dispatch(updateNewChat(true));
        setName("");
        setLoading(false);
        onClose();
      }
    } catch (error) {
      console.log("Failed to edit chat name", error);
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Edit Chat Name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Name</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button
          className="send-invite__btn"
          onClick={editChatName}
          disabled={loading}
          style={loading ? { backgroundColor: "#268bd9", border: "none", paddingLeft: '1rem' } : {}}
        >
          {loading && <Spinner />}
          <span className="send-invite-button__label">
            {loading ? "Saving" : "Save"}
          </span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditChatNameModal;
